import React from "react";
import { useTranslation } from "react-i18next";
import { ChevronLeft, ChevronRight, Calendar as CalendarIcon } from "lucide-react";
import { Button } from "../ui/button";

const CalendarNavigation = ({ navigatePrevious, navigateNext, goToToday, viewModeLabel }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between">
      <Button variant="outline" onClick={navigatePrevious}>
        <ChevronLeft className="h-4 w-4 mr-1" /> {t("planning.calendarView.previous")}
      </Button>
      <div className="flex items-center gap-2">
        <CalendarIcon className="h-4 w-4 text-muted-foreground" />
        <span className="font-medium">{viewModeLabel}</span>
        <Button variant="outline" size="sm" onClick={goToToday}>{t("planning.calendarView.today")}</Button>
      </div>
      <Button variant="outline" onClick={navigateNext}>
        {t("planning.calendarView.next")} <ChevronRight className="h-4 w-4 ml-1" />
      </Button>
    </div>
  );
};

export default CalendarNavigation;
